import Helmet from "../../abis/HELMET.json";
import Drill from "../../abis/Drill.json";
import Axe from "../../abis/Axe.json";
import Shovel from "../../abis/Shovel.json";
import Hammer from "../../abis/Hammer.json";

import shovel from "../images/ui/shovel.png";
import axe from "../images/ui/axe.png";
import drill from "../images/ui/drill.png";
import hammer from "../images/ui/hammer.png";
import helmet from "../images/ui/helmet.png";
import coin from "../images/ui/icon.png";
import bnb from "../images/ui/coin-avax.png";
import busd from "../images/ui/coin-avax.png";

export interface Ingredient {
  name: "$AVAX";
  image: any;
  amount: number;
}

export interface Recipe extends Item {
  ingredients: Ingredient[];
}

export interface Item {
  name: "Axe" | "Hammer" | "Drill" | "Shovel" | "Helmet";
  description: string;
  address: string;
  image: any;
  type: "ERC20" | "NFT";
  isLocked?: boolean;
  supply?: number;
  limit?: number;
  abi?: any;
  openSeaLink?: string;
}

export const recipes: Recipe[] = [
  {
    name: "Axe",
    description: "Axe makes 3x faster Phospate",
    image: axe,
    type: "NFT",
    address: "0x7eE07c10184fE6A44546AEfecd78B9347ec08fc2",
    ingredients: [
      {
        name: "$AVAX",
        amount: 2.5,
        image: busd,
      },
    ],
    abi: Axe,
    supply: 2000,
  },
  {
    name: "Hammer",
    description: "Hammer makes 3x faster Sulfur",
    image: hammer,
    type: "NFT",
    address: "0x53BbF088BDf6BB14AcE11e83A604d694138FfA35",
    ingredients: [
      {
        name: "$AVAX",
        amount: 2.5,
        image: busd,
      },
    ],
    abi: Hammer,
    supply: 2000,
  },
  {
    name: "Drill",
    description: "Drill makes 3x faster Diamonds",
    image: drill,
    type: "NFT",
    address: "0xFaFC4259E11616504effF7957Ffa998316f8610d",
    ingredients: [
      {
        name: "$AVAX",
        amount: 2.5,
        image: busd,
      },
    ],
    abi: Drill,
    supply: 2000,
  },
  {
    name: "Shovel",
    description: "Shovel owners get chests every 3days",
    image: shovel,
    type: "NFT",
    address: "0xB358c680F5342FB2DAb2fA5ea407C478D90F3d79",
    ingredients: [
      {
        name: "$AVAX",
        amount: 4,
        image: busd,
      },
    ],
    abi: Shovel,
    supply: 1000,
  },
  {
    name: "Helmet",
    description:
      "HELMET let user get AVAX rewards from pool and every minted NFT for free",
    image: helmet,
    type: "NFT",
    address: "0xbc7eEC59BF24bbf4D20Dd4822DF7bABD8C1D37e9",
    ingredients: [
      {
        name: "$AVAX",
        amount: 5,
        image: bnb,
      },
    ],
    abi: Helmet,
    supply: 1000,
  },
];

export const items: Item[] = [...recipes];

export type Inventory = Record<ItemName, number>;

export const DEFAULT_INVENTORY: Inventory = {
  Axe: 0,
  Hammer: 0,
  Drill: 0,
  Shovel: 0,
  Helmet: 0,
};
export type ItemName = Item["name"];
